module.exports = __webpack_public_path__ + "img/Ifema.4a4e0e69.png";